"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const chatEvents_1 = __importDefault(require("./lib/chatEvents"));
const configureStore_1 = require("./store/configureStore");
const RoomList = ({ rooms, socket }) => {
    const [headCount, setHeadCount] = (0, react_1.useState)({});
    const { handleRoom, handleStep } = (0, react_1.useContext)(configureStore_1.StoreContext);
    const Events = new chatEvents_1.default(socket);
    (0, react_1.useEffect)(() => {
        Events.receiveRoomHeadCount(setHeadCount);
        const healthCheck = setInterval(() => Events.getHeadCount(), 1000);
        return () => {
            clearInterval(healthCheck);
            setHeadCount({});
        };
    }, []);
    const joinRoom = (room) => {
        Events.joinRoom(room);
        handleRoom(room);
        handleStep(5);
    };
    return (react_1.default.createElement("article", { "data-testid": "room-list", style: {
            position: "absolute",
            display: "flex",
            flex: "1",
            flexFlow: "column nowrap",
            width: "100%",
            height: "100%",
            background: "rgb(255 92 3 / 50%)",
            overflow: "auto",
            textAlign: "center",
        } },
        react_1.default.createElement("h2", { style: {
                padding: "8px",
                fontSize: "1.5rem",
                color: "#325332"
            } }, "\uCC38\uC5EC \uAC00\uB2A5\uD55C \uCC44\uD305\uBC29 \uBAA9\uB85D"),
        react_1.default.createElement("ul", { "data-testid": "rooms", style: {
                width: "100%",
                maxWidth: "500px",
                margin: "33px auto",
                padding: 0,
                listStyle: "none",
            } }, rooms.map((room, idx) => {
            var _a;
            return react_1.default.createElement("li", { key: idx, onClick: () => joinRoom(room), style: {
                    margin: "16px",
                    padding: "16px",
                    fontSize: "1.1rem",
                    color: "whitesmoke",
                    border: "1px solid #fff"
                }, onMouseOver: (e) => e.target.style.color = '#dc1f1f', onMouseLeave: (e) => e.target.style.color = 'whitesmoke' },
                room,
                " (",
                ((_a = headCount[room]) === null || _a === void 0 ? void 0 : _a.length) || 0,
                ")");
        }))));
};
exports.default = RoomList;
